import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DashboardState, StoreState } from "types/state/StoreState";

import { Business, DashboardSummary } from "types/Dashboard";
import {
  getDashboardSummary,
  getOwnerAllBusinessApi
} from "services/api/dashboardApi";
import { getBusinessCardApi } from "services/api/settingsApi";
import { CommonRequest } from "types/common";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    isLoading: false,
    dashboardSummary: {},
    businessCard: {},
    allBusiness: [] as Business[]
  } as DashboardState,
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setDashboardSummary(state, action) {
      state.dashboardSummary = action.payload;
    },
    setBusinessCard(state, action) {
      state.businessCard = action.payload;
    },
    setAllBusiness(state, action) {
      state.allBusiness = action.payload;
    }
  }
});
// Thunk Actions

export const getDashboardSummaryThunk = createAsyncThunk(
  "dashboard/getDashboardSummaryThunk",
  async (request: CommonRequest, thunkApi) => {
    const { dispatch } = thunkApi;
    const { accessToken, businessId } = request;
    dispatch(dashboardSlice.actions.setIsLoading(true));

    const [summary, business] = await Promise.all([
      getDashboardSummary(accessToken, businessId),
      getOwnerAllBusinessApi(accessToken)
    ]);
    // Replace business - branch to branch - business
    const updatedData = business.map((item) => ({
      ...item,
      name: item.name.replace(/^(.*) - (.*)$/, "$2 - $1")
    }));
    dispatch(dashboardSlice.actions.setDashboardSummary(summary));
    dispatch(dashboardSlice.actions.setAllBusiness(updatedData));
    dispatch(dashboardSlice.actions.setIsLoading(false));
  }
);

export const getBusinessCardThunk = createAsyncThunk(
  "dashboard/getBusinessCardThunk",
  async (request: CommonRequest, thunkApi) => {
    const { dispatch } = thunkApi;
    const { accessToken, businessId } = request;
    dispatch(dashboardSlice.actions.setIsLoading(true));
    const card = await getBusinessCardApi(accessToken, businessId);
    dispatch(dashboardSlice.actions.setBusinessCard(card));
    dispatch(dashboardSlice.actions.setIsLoading(false));
  }
);

// Reducers
export const getLoadingStatus = (state: StoreState): boolean =>
  state.dashboard.isLoading;
export const getDashboard = (state: StoreState): DashboardSummary =>
  state.dashboard.dashboardSummary;
export const getBusinessCard = (state: StoreState): Business =>
  state.dashboard.businessCard;
export const getAllBusiness = (state: StoreState): Business[] =>
  state.dashboard.allBusiness;
// export const getBusinessSubscriptionEnabled = (state: StoreState): boolean =>
//   state.dashboard.dashboardSummary.business.subscription_enabled;
export default dashboardSlice.reducer;
